import React from 'react'
import styled from 'styled-components'
// @ts-ignore
import { sys } from '@netbasequid/theme'
// @ts-ignore
import { Tooltip } from '@netbasequid/core'
import { AutomationId, AUTO_ATTR_KEY } from 'utils/automationUtil'
import { Theme } from 'features/ui/types'
import { useDisplayTheme } from 'hooks/useUiState'
import { CountTypeStrings } from 'enums/CountType'
import messageUtil from 'utils/messageUtil'
import { StyledTitle } from '../../index.css'
import useTitleHasTooltip from '../../hooks'

const StyledName = styled.span.attrs({
  [AUTO_ATTR_KEY]: AutomationId.insightModal.insightContent.overview.selectedTerm
})`
  font-weight: ${sys.fontWeight.semibold};
`

const Title = ({
  countType,
  selectionName
}: {
  countType: CountTypeStrings
  selectionName: React.ReactNode
}) => {
  const theme = useDisplayTheme() as Theme
  const { displayTooltip, titleContentRef } = useTitleHasTooltip()

  return (
    <StyledTitle mode={theme} ref={titleContentRef as React.MutableRefObject<HTMLDivElement>}>
      <Tooltip mode={theme} enabled={displayTooltip} content={selectionName}>
        <div>
          <StyledName>{selectionName}</StyledName>&nbsp;
          {messageUtil.countType(countType)}
        </div>
      </Tooltip>
    </StyledTitle>
  )
}

export default Title
